import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, Chip, ClickAwayListener, FormControl, InputLabel, MenuItem, Select, Typography } from "@material-ui/core";
import useStyles, { BootstrapInput } from "./style";
import { Icons } from "../../assets";

const { OpenedDropdownIcon, ClosedDropdownIcon } = Icons;












































function SelectComponent(props) {
  const {
    multiple,
    items,
    label,
    placeholder,
    selected,
    onChange,
    triggerReset,
    native = false,
    disabled = false,
    margin,
  } = props;
  const classes = useStyles();
  const [value, setValue] = useState(selected || (multiple ? [] : ""));
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setValue(multiple ? [] : "");
  }, [triggerReset, multiple]);

  useEffect(() => {
    if (selected) {
      setValue(selected);
    }
  }, [selected]);

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    setOpen((previous) => {
      if (multiple && !(event.target instanceof HTMLElement)) {
        return true;
      }
      return !previous;
    });
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleDelete = (selectedValue) => () => {
    const newValue = (Array.isArray(value) && value.filter((chip) => chip !== selectedValue));
    setValue(newValue || multiple ? [] : "");
    onChange(newValue || "");
  };

  return (
    React.createElement(Box, { className: classes.selectContainer,}
      , React.createElement(ClickAwayListener, { onClickAway: handleClickAway,}
        , React.createElement(FormControl, { className: classes.selectFormControl,}
          , React.createElement(InputLabel, { className: classes.selectFormLabel,}, label)
          , React.createElement(Select, {
            'aria-label': label,
            value: value,
            native: native,
            disabled: disabled,
            multiple: multiple,
            margin: margin,
            onChange: handleChange,
            onClick: handleClick,
            open: isOpen,
            input: React.createElement(BootstrapInput, null ),
            label: label,
            tabIndex: 0,
            displayEmpty: true,
            renderValue: (selectValue) => {
              const field = items.find((item) => item.value === selectValue)

              return multiple && value.length !== 0 ? (
                React.createElement('div', { className: classes.selectChips,}
                  , selectValue.map((selectedValue) => {
                    const selectedItem = items.find((el) => el.value === selectedValue);

                    return (
                      React.createElement(Chip, {
                        key: selectedItem?.value,
                        label: selectedItem?.label,
                        onDelete: handleDelete(selectedValue),
                        className: classes.selectChip,
                        clickable: true,}
                      )
                    );
                  })
                )
              ) : (
                React.createElement(Typography, null
                  , value.length === 0 ? placeholder || "" : field?.label
                )
              );
            },
            IconComponent: () =>
              !isOpen ? (
                React.createElement(ClosedDropdownIcon, { className: classes.selectIcon,} )
              ) : (
                React.createElement(OpenedDropdownIcon, { className: classes.selectIcon,} )
              )
            ,
            MenuProps: {
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            },}
          
            , placeholder && !multiple && (
              React.createElement(MenuItem, { value: [],}, placeholder)
            )
            , native
              ? items &&
                items.map((item) => (
                  React.createElement('option', { value: item.value, key: item.value,}
                    , item.label
                  )
                ))
              : items &&
                items.map((item) => (
                  React.createElement(MenuItem, { key: item.value, value: item.value,}
                    , multiple && (
                      React.createElement(Checkbox, {
                        color: "primary",
                        checked: value.includes(item.value) || false,}
                      )
                    )
                    , item.label
                  )
                ))
          )
        )
      )
    )
  );
}

export function Filter(props) {
  const { filters, onChangeFilters } = props;
  const classes = useStyles();

  const [selectedFilters, setSelectedFilters] = useState({ ...props.selectedFilters });
  const [reset, triggerReset] = useState(false);

  const clearAll = () => {
    setSelectedFilters({});
    triggerReset((el) => !el);
  };

  useEffect(() => {
    onChangeFilters(selectedFilters);
  }, [selectedFilters, onChangeFilters]);

  return (
    React.createElement(Box, { className: classes.filterContainer,}
      , React.createElement(Box, { className: classes.filterHeader,}
        , React.createElement(Typography, { className: classes.filterTitle,}, "Filters")
        , React.createElement(Button, { className: classes.filterClear, color: "primary", onClick: clearAll,}, "Clear All" )
      )
      , React.createElement(Box, null
        , filters.map(({ component, ...filter}) => {
          if (component) {
            return component(
              filter.element, 
              (customSelectedFilters) => {
                setSelectedFilters({
                  ...selectedFilters,
                  ...customSelectedFilters
                })
              }, 
              selectedFilters
            );
          }

          return (
            React.createElement(SelectComponent, { 
              triggerReset: reset,
              key: filter.element.label,
              selected: selectedFilters[filter.element.label],
              onChange: (value) =>
                setSelectedFilters({
                  ...selectedFilters,
                  [filter.element.label]: value,
                })
              ,
              ...filter.element,}
            )
          )
        })
      )
    )
  );
}